import React, { useState } from 'react';
import WordDefinitionExercise from './WordDefinitionExercise';
import './WordDefinitionExerciseBoard.css';

const WORD_DEFINITION_ICON = (
  <span style={{
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 48, height: 48, borderRadius: 12, background: 'linear-gradient(135deg, #d97706 0%, #f59e0b 100%)', marginRight: 20
  }}>
    <svg width="24" height="24" viewBox="0 0 512 512" fill="white">
      <g>
        <g>
          <path d="M260.995,227.715c-9.623,3.423-19.995-3.716-19.995-14.15V121h-71.455c-12.947,0-19.804,15.351-11.177,25.005
            C163.29,151.498,166,158.603,166,166c0,16.538-13.462,30-30,30c-16.538,0-30-13.462-30-30c0-7.397,2.71-14.502,7.632-19.995
            c8.627-9.654,1.77-25.005-11.177-25.005H45c-24.814,0-45,20.186-45,45v180c0,24.814,20.186,45,45,45h31c0,33.091,26.909,60,60,60
            s60-26.909,60-60h45v-92.563c0-10.296,10.712-17.369,19.995-14.15c18.633,6.636,39.99-8.335,40.005-28.286
            C301,236.021,279.657,221.064,260.995,227.715z"/>
        </g>
      </g>
      <g>
        <g>
          <path d="M467,121h-31c0-33.091-26.909-60-60-60s-60,26.909-60,60h-45v75c33.091,0,60,26.909,60,60s-26.909,60-60,60v75h196
            c24.814,0,45-20.186,45-45V166C512,141.186,491.814,121,467,121z"/>
        </g>
      </g>
    </svg>
  </span>
);

const WordDefinitionExerciseBoard = ({
  exerciseData, exerciseType: _exerciseType, onUpdate, isSelected, onSelect, onExpand,
  isExpanded: isExpandedProp, onClose,
  isStudent = false, myState = {}, otherState = {}, updateState = () => {},
}) => {
  const [isExpandedLocal, setIsExpandedLocal] = useState(false);
  const isExpanded = isExpandedProp !== undefined ? isExpandedProp : isExpandedLocal;
  const { pairs, title, level } = exerciseData;

  if (!pairs || !Array.isArray(pairs)) {
    return (
      <div className="word-definition-board-error">
        <p>Error: Invalid Word Definition exercise data</p>
      </div>
    );
  }

  return (
    <div className="word-definition-exercise-board">
      {!isExpanded ? (
        <div
          className={`word-definition-preview unified-exercise-preview wd-board-card${isSelected ? ' is-selected' : ''}`}
          onClick={() => {
            if (isExpandedProp === undefined) setIsExpandedLocal(true);
            if (onSelect) onSelect();
            if (onExpand) onExpand();
          }}
        >
          {WORD_DEFINITION_ICON}
          <div className="unified-preview-main">
            <div className="unified-preview-title">{title || 'Word Definition Exercise'}</div>
            <div className="unified-preview-meta">
              {pairs.length} word pairs · Level: {level || 'B1'}
            </div>
          </div>
          <button className="unified-preview-btn">
            Start Exercise
          </button>
        </div>
      ) : (
        <div className="wde-expanded">
          <WordDefinitionExercise
            pairs={pairs}
            title={title}
            level={level}
            onClose={() => { if (isExpandedProp === undefined) setIsExpandedLocal(false); if (onClose) onClose(); }}
            onUpdate={onUpdate}
            isBoard={true}
            isStudent={isStudent}
            myState={myState}
            otherState={otherState}
            updateState={updateState}
          />
        </div>
      )}
    </div>
  );
};

export default WordDefinitionExerciseBoard; 